const angular = require('angular')
/* Animations */

const animationsMoudle = angular.module('hxphone.animations', ['ngAnimate'])

/**
 * 定义动画的工厂方法
 */
animationsMoudle.factory('animateCSSBuildFactory', function() {
  return function(baseTransition, showAttr, hideAttr) {
    const attrs = {
      enter: showAttr,
      leave: hideAttr
    }
    const animateCSSShow = function(element, baseTransition, directionAttr, done) {
      element.attr('data-transition', baseTransition)
      element.attr('data-direction', directionAttr)

      const events = 'animationend webkitAnimationEnd transitionend webkitTransitionEnd'
      element.one(events, function() {
        element.removeAttr('data-direction')
        // 新section在换进来时默认隐藏，在这里才显示。这样子做是为了解决换页时的视图抖动
        element.css({'opacity': 1})
        done()
      })
    }
    const animateCSSHide = function(element, baseTransition, directionAttr, done) {
      element.attr('data-transition', baseTransition)
      element.attr('data-direction', directionAttr)

      const events = 'animationend webkitAnimationEnd transitionend webkitTransitionEnd'
      element.one(events, function() {
        element.removeAttr('data-direction')
        element.css({'opacity': 0})
        done()
      })
    }

    return {
      enter: function(element, done) {
        animateCSSShow(element, baseTransition, attrs.enter, done)
      },
      leave: function(element, done) {
        animateCSSHide(element, baseTransition, attrs.leave, done)
      }
    }
  }
})

/**
 * 定义各种动画效果
 */
animationsMoudle
  // .animation('.animate-fade', ['animateCSSBuildFactory', function(animateCSSBuildFactory) {
  //   return animateCSSBuildFactory('fade', 'in', 'out')
  // }])
  // .animation('.animate-fadeBack', ['animateCSSBuildFactory', function(animateCSSBuildFactory) {
  //   return animateCSSBuildFactory('fadeBack', 'back-in', 'back-out')
  // }])
  // .animation('.animate-slide', ['animateCSSBuildFactory', function(animateCSSBuildFactory) {
  //   return animateCSSBuildFactory('slide', 'in', 'out')
  // }])
  // .animation('.animate-slideBack', ['animateCSSBuildFactory', function(animateCSSBuildFactory) {
  //   return animateCSSBuildFactory('slideBack', 'back-in', 'back-out')
  // }])
  // .animation('.animate-cover', ['animateCSSBuildFactory', function(animateCSSBuildFactory) {
  //   return animateCSSBuildFactory('cover', 'in', 'out')
  // }])
  // .animation('.animate-coverBack', ['animateCSSBuildFactory', function(animateCSSBuildFactory) {
  //   return animateCSSBuildFactory('coverBack', 'back-in', 'back-out')
  // }])
  .animation('.slide-fade-in-down', ['$animateCss', function($animateCss) {
    return {
      enter: function(element) {
        return $animateCss(element, {
          easing: 'ease-out',
          from: { opacity: 0, transform: 'translateY(-20px)' },
          to: { opacity: 1, transform: 'translateY(0px)' },
          duration: 0.2
        })
      },
      leave: function(element) {
        return $animateCss(element, {
          easing: 'ease-in',
          from: { opacity: 1, transform: 'translateY(0px)' },
          to: { opacity: 0, transform: 'translateY(-20px)' },
          duration: 0.2
        })
      }
    }
  }])
  .animation('.fade-in-out', ['$animateCss', function($animateCss) {
    return {
      enter: function(element) {
        return $animateCss(element, {
          easing: 'fade-in',
          from: { opacity: 0, transform: 'scale(0.98)' },
          to: { opacity: 1, transform: 'scale(1)' },
          duration: 0.2
        })
      },
      leave: function(element) {
        return $animateCss(element, {
          easing: 'fade-out',
          from: { opacity: 1, transform: 'scale(1)' },
          to: { opacity: 0, transform: 'scale(0.98)' },
          duration: 0.2
        })
      }
    }
  }])

module.exports = animationsMoudle



// WEBPACK FOOTER //
// ./src/js/animations.js